import Image from 'next/image';

const LOGO_GREEN = '/logo/kindway-thumbnail-green-128.png';
const LOGO_WHITE = '/logo/kindway-logo-white.png';

type LogoIconVariant = 'default' | 'thumbnail' | 'thumbnail-white';

interface LogoIconProps {
  className?: string;
  variant?: LogoIconVariant;
  /** Rounded corners for the square (thumbnail variants). Default: rounded-xl */
  rounded?: string;
  /** When true, load eagerly with high fetch priority (use for above-the-fold / LCP candidates). */
  priority?: boolean;
  /** Responsive `sizes` for next/image (recommended when `priority` is set). */
  sizes?: string;
}

export function LogoIcon({
  className = 'w-8 h-8',
  variant = 'default',
  rounded = 'rounded-xl',
  priority = false,
  sizes,
}: LogoIconProps) {
  const imgSrc = variant === 'thumbnail-white' ? LOGO_WHITE : LOGO_GREEN;

  const imageProps = {
    src: imgSrc,
    alt: '',
    width: variant === 'default' ? 504 : 128,
    height: variant === 'default' ? 504 : 128,
    priority,
    fetchPriority: priority ? ('high' as const) : undefined,
    sizes,
  };

  if (variant === 'default') {
    return <Image {...imageProps} className={className} />;
  }

  const bgClass =
    variant === 'thumbnail'
      ? 'bg-white'
      : 'bg-primary';

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center p-[10%] ${rounded} ${bgClass} ${className}`}
    >
      <Image {...imageProps} className="h-full w-full object-contain" />
    </span>
  );
}
